import { Box } from "@mui/material";
import { Button } from "pepsico-ds";
export const CommonBuilderComponent = ({ children }) => {
  return (
    <Box
      sx={{
        display: "flex",
        padding: "10px 32px 32px 32px",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "16px",
        alignSelf: "stretch",
        borderRadius: "8px", // --Corner-radius-corner-radius-small
        border: "1px solid #D7E5F8", // --Tokens-Border-Default
        background: "#FBFCFE", // --Tokens-Background-Layer-01
      }}
    >
      {children}
    </Box>
  );
};

export const DeleteBuilderButton = ({ label, onClick }) => {
  return (
    <Button
      variant="tertiary"
      size="large"
      text={label}
      iconTrailing="delete"
      onClick={onClick}
      type="button"
    />
  );
};

export const AddBuilderButton = ({ label, onClick, disabled, type }) => {
  return (
    <Button
      variant="tertiary"
      size="large"
      text={label}
      iconTrailing="note_add"
      onClick={onClick}
      disabled={disabled}
      type={type}
    />
  );
};
